import en from "./en.json";

export const resources = { en };
